import Slider from '../components/slider';
import StickyContent from '../components/sticky-content';

new Slider('.c-image-slider__slider', {
  autoplay: {
    delay: 8500,
  },
  loop: false,
  navigation: {
    nextEl: '.c-image-slider__arrow--next',
    prevEl: '.c-image-slider__arrow--prev',
    disabledClass: 'c-image-slider__arrow--disabled'
  }
});

const stickyContents = document.querySelectorAll('.c-image-slider__slider');
stickyContents.forEach((element, index) => {
  new StickyContent({
    element: element,
    offset: 0,
    debugId: 'element ' + index,
  });
});


// WEBPACK FOOTER //
// ./scripts/wpbakery/image-slider.js